import './index.css';
import './i18n';
import './lib/maplibre-worker';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { ApiError } from '@ooh/contracts';
import { QueryClientProvider } from '@tanstack/react-query';
import { createAppRouter } from './router';
import { queryClient } from './lib/app-runtime';
import { initSentry, Sentry } from './lib/sentry';

// Initialise Sentry before the app renders. No-op when VITE_SENTRY_DSN is unset.
initSentry();

const router = createAppRouter(queryClient);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

ReactDOM.createRoot(rootElement, {
  // A screen's QueryBoundary renders an HTTP failure (404 link, 410 expired) as a normal state.
  // React's default would log it as a console error, which the e2e noErrors fixture treats as a bug.
  onCaughtError: (error, errorInfo) => {
    if (error instanceof ApiError) return;
    console.error(error, errorInfo.componentStack);
  },
}).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
